/** Theme selection, persisted and mirrored onto the scene background. */

import { getEngine } from "../engine/engine.actions.ts";
import { type Theme, themeState } from "./theme.state.ts";

const STORAGE_KEY = "haki.theme";

function apply(theme: Theme): void {
  if (theme === "light") {
    document.documentElement.dataset.theme = "light";
  } else {
    delete document.documentElement.dataset.theme;
  }
}

/** Read the stored preference at boot, before React mounts. Light unless asked otherwise. */
export function applyStoredTheme(): void {
  const stored = localStorage.getItem(STORAGE_KEY);
  const theme: Theme = stored === "dark" ? "dark" : "light";

  themeState.set({ theme });
  apply(theme);
}

export function setTheme(theme: Theme): void {
  themeState.set({ theme });
  apply(theme);
  localStorage.setItem(STORAGE_KEY, theme);
  getEngine().setTheme(theme);
}

export function toggleTheme(): void {
  setTheme(themeState.get().theme === "dark" ? "light" : "dark");
}
